module.exports = __webpack_public_path__ + "assets/character1_cheerup.2c69342e.svg";